import { render, staticRenderFns } from "./PluginHeader.vue?vue&type=template&id=5a3d8a0e&scoped=true&"
import script from "./PluginHeader.vue?vue&type=script&lang=js&"
export * from "./PluginHeader.vue?vue&type=script&lang=js&"
import style0 from "./PluginHeader.vue?vue&type=style&index=0&id=5a3d8a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d8a0e",
  null
  
)

export default component.exports